import type { Element as XmlEl } from "@xmpp/xml"
import { attr } from "../../../xmlUtils"
import { InvalidStanza } from "../exceptions"
import type { RetractionMessage } from "../../../../types"
import { NS_MESSAGE_RETRACT } from "../../../constants"

function retract(stanza: XmlEl) {
  return stanza.getChild("retract", NS_MESSAGE_RETRACT)
}

export function isRetraction(stanza: XmlEl): boolean {
  return !!retract(stanza)
}

export function parseRetraction(
  stanza: XmlEl
): Pick<RetractionMessage, "type" | "retractedMessageId"> {
  const tag = retract(stanza)
  if (!tag) throw new InvalidStanza("not a retraction", stanza)

  const retractedMessageId = attr(tag, "id")
  if (!retractedMessageId)
    throw new InvalidStanza("retraction names no message", stanza)

  return { type: "retraction", retractedMessageId }
}
